import Select, { PropsValue } from "react-select";
import Pacman from "../layout/Pacman";
import { SingleValue } from "react-select";
import { SimpleFormSelectOption } from "../form/SimpleFormSelect";

type TDefaultSelected = {
    value: number | string | undefined;
    defaultValue?: PropsValue<any>;
    onChange(value?: number | string): void;
    isClearable?: boolean;
    options?: SimpleFormSelectOption[] | undefined;
    isLoading?: boolean;
    isSearchable?: boolean;
};
const DefaultSelected = (props: TDefaultSelected) => {
    const {
        value,
        onChange,
        options = [],
        isLoading = false,
        isClearable,
        isSearchable = true,
        defaultValue,
    } = props;
    const asValue = value ? options.find((option) => value === option.value) : "";

    return (
        <div style={{ marginLeft: "8px" }}>
            <Select
                defaultValue={defaultValue}
                options={options}
                isSearchable={isSearchable}
                isLoading={isLoading}
                isClearable={isClearable}
                value={asValue}
                components={{ LoadingIndicator: () => <Pacman size={8} /> }}
                onChange={(
                    newValue: SingleValue<
                        | string
                        | {
                              label: string;
                              value: string | number;
                          }
                    >
                ) => {
                    if (typeof newValue != "string") onChange(newValue?.value);
                }}
            />
        </div>
    );
};
export default DefaultSelected;
